import { useEffect } from 'react';
const SIDE_EFFECT_EVENT_NAME = 'ai-assistant--side-effect';
export const useSideEffectListener = _ref => {
  let {
    connection,
    onSideEffect,
    filter
  } = _ref;
  const {
    channel
  } = connection;
  useEffect(() => {
    const onEventWrapper = eventPayload => {
      for (const key in filter) {
        const paramKey = key;
        if (filter[paramKey] !== undefined && filter[paramKey] !== eventPayload[paramKey]) {
          return;
        }
      }
      onSideEffect(eventPayload.payload, eventPayload);
    };
    channel == null || channel.addEventListener(SIDE_EFFECT_EVENT_NAME, onEventWrapper);
    return () => void (channel == null ? void 0 : channel.removeEventListener(SIDE_EFFECT_EVENT_NAME, onEventWrapper));
  }, [onSideEffect, channel, filter]);
};
//# sourceMappingURL=useSideEffectListener.js.map